// /client/src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/Routes';
import { OrderModalProvider } from './contexts/OrderModalContext';
import OrderModal from './components/OrderModal';
import { initializeCookieBanner, initializeAnalyticsIfConsented } from './utils/cookieBanner';
import { usePageTracking } from './hooks/useAnalytics';
import 'bulma/css/bulma.min.css';

// Component to handle page tracking (must be inside Router)
const PageTracker = () => {
  usePageTracking();
  return null;
};

const App = () => {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Initialize cookie banner when component mounts
    const initializeBanner = () => {
      // Small delay to ensure SilkTide scripts are loaded
      setTimeout(() => {
        initializeCookieBanner();
        // Initialize analytics if user has already consented
        initializeAnalyticsIfConsented();
      }, 100);
    };

    // Check if document is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBanner);
    } else {
      initializeBanner();
    }

    // Cleanup
    return () => {
      document.removeEventListener('DOMContentLoaded', initializeBanner);
    };
  }, []);

  return (
    <>
      <main id="main" className="hide-this"></main>
      <div className="App">
        <Router>
          <PageTracker />
          <OrderModalProvider>
            <Routes />
            {/* Modal renders globally but only shows when isOpen = true */}
            <OrderModal />
          </OrderModalProvider>
        </Router>
      </div>
    </>
  );
};

export default App;